<template>
  <div class="printAgenda">
    <h1>Agenda for {{ user.firstname }} {{ user.lastname }}</h1>

    <section>
      <div class="conference-title">Name of the Conference</div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Time</th>
            <th scope="col">Teacher/Team</th>
            <th scope="col">Student</th>
            <th scope="col">Parent</th>
            <th scope="col">Location</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-col="Date: ">Tue, Nov 1, 2022</td>
            <td data-col="Time: ">6:15 PM</td>
            <td data-col="Teacher/Team: ">Madison Abelle</td>
            <td data-col="Student: ">Megal Abelle</td>
            <td data-col="Parent: ">Shammai Ellman</td>
            <td data-col="Location: ">Room 123</td>
          </tr>
          <tr>
            <td data-col="Date: ">Tue, Nov 1, 2022</td>
            <td data-col="Time: ">6:15 PM</td>
            <td data-col="Teacher/Team: ">Madison Abelle</td>
            <td data-col="Student: ">Megal Abelle</td>
            <td data-col="Parent: ">Shammai Ellman</td>
            <td data-col="Location: ">Virtual Meeting</td>
          </tr>
          <tr>
            <td data-col="Date: ">Tue, Nov 1, 2022</td>
            <td data-col="Time: ">6:15 PM</td>
            <td data-col="Teacher/Team: ">Madison Abelle</td>
            <td data-col="Student: ">Megal Abelle</td>
            <td data-col="Parent: ">Shammai Ellman</td>
            <td data-col="Location: ">Room 123, Virtual Meeting</td>
          </tr>
        </tbody>
      </table>
    </section>

    <footer>
      <!-- <p>Generated at 12:00 AM on Tue, Jan 01, 2022 by PTC Wizard</p> -->
      <p>Generated at {{ dayjs().format("h:mm A on ddd, MMM Do, YYYY") }} by PTC Wizard</p>
      <figure class="logo" alt="PTC Wizard Logo">
        <Logo />
      </figure>
    </footer>
  </div>
</template>
<script setup>
import dayjs from "dayjs";
import advancedFormat from "dayjs/esm/plugin/advancedFormat";

// import { useAgendaStore } from '@/stores/teacher/agenda';
import Logo from "@/assets/icons/logo-vertical-regular.svg";

// const agendaStore = useAgendaStore();
const props = defineProps({
  conferences: Array,
  school: Array,
  agenda: Array,
  user: Object
});

dayjs.extend(advancedFormat);
// eslint-disable-next-line
function getAgendaByConference(conferenceId) {
  return props.agenda
    .filter((meeting) => meeting.conference_id == conferenceId)
    .sort((a, b) => {
      return a.start < b.start ? -1 : 1;
    });
}
// eslint-disable-next-line
function getAgenda() {
  if (props.conference !== undefined) {
    return props.agenda
      .filter((meeting) => meeting.conference_id == props.conference.conference_id)
      .sort((a, b) => {
        return a.start < b.start ? -1 : 1;
      });
  } else {
    console.log(props.agenda);
    return props.agenda;
  }
}
</script>
